import apiBase from '@/services/api-base';

// Types matching backend payload
export interface ReportsOverviewGrowth { books: number; users: number; loans: number; returns: number; }
export interface ReportsOverview {
  totalBooks: number;
  totalUsers: number;
  activeLoans: number;
  overdueBooks: number;
  monthlyGrowth: ReportsOverviewGrowth;
  // Extended KPI fields
  averageLoanDurationDays: number;
  collectionUtilizationPercentage: number;
  avgBooksPerUser: number;
  avgDailyReturns: number;
  returnRatePercentage: number;
}
export interface ReportsCategoryItem { category: string; count: number; }
export interface ReportsPopularBook { title: string; isbn: string; borrowCount: number; }
export interface ReportsUserRoleItem { role: string; count: number; }
export interface ReportsLoanStatusItem { status: string; count: number; }
export interface ReportsMonthlyTrendItem { month: string; borrowed: number; returned: number; }

export interface ReportsDashboardPayload {
  overview: ReportsOverview;
  books: { byCategory: ReportsCategoryItem[]; popular: ReportsPopularBook[] };
  users: { byRole: ReportsUserRoleItem[] };
  loans: { byStatus: ReportsLoanStatusItem[]; monthlyTrends: ReportsMonthlyTrendItem[] };
}

export const reportsApi = {
  // Use relative path because apiBase already includes /api/v1 base
  getDashboard: () => apiBase.get<ReportsDashboardPayload>('/reports/dashboard/'),
};

export type { ReportsDashboardPayload as ReportsDashboard };
